const getDefaultConfigs = (isEquity, isFuture) => {
  return {
    productCode: (isEquity) ? 'CNC' : 'NRML',
  };
};

export { getDefaultConfigs };